var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6378 16.4693L13.9215 12.7531C16.4181 9.66712 16.1971 5.10778 13.3731 2.29195C11.8915 0.810368 9.927 0 7.8315 0C5.73601 0 3.77149 0.810368 2.2899 2.29195C-0.763301 5.34516 -0.763301 10.322 2.2899 13.3752C3.77149 14.8568 5.73601 15.6671 7.8315 15.6671C9.57502 15.6671 11.2776 15.0778 12.6446 14.0136L16.369 17.7381C16.5409 17.91 16.7619 18 16.9993 18C17.2367 18 17.4659 17.91 17.6296 17.7381C17.9898 17.3861 17.9898 16.8213 17.6378 16.4693ZM13.8806 7.83356C13.8806 9.44611 13.2503 10.9686 12.1125 12.1064C10.9748 13.2524 9.45225 13.8745 7.8397 13.8745C6.22715 13.8745 4.70464 13.2442 3.56685 12.1064C2.42087 10.9604 1.79877 9.44611 1.79877 7.83356C1.79877 6.22101 2.42906 4.6985 3.56685 3.56071C4.71282 2.41473 6.22715 1.79263 7.8397 1.79263C9.45225 1.79263 10.9748 2.42292 12.1125 3.56071C13.2503 4.6985 13.8806 6.22101 13.8806 7.83356Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.87ce7ee9.svg";
export { ForwardRef as ReactComponent };